import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import type { GroupLeaderResponse } from "@/types/admin";

interface SurveyBasicInfoProps {
  formData: GroupLeaderResponse;
  onInputChange: (field: keyof GroupLeaderResponse, value: any) => void;
}

export const SurveyBasicInfo = ({ formData, onInputChange }: SurveyBasicInfoProps) => {
  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <Label htmlFor="date">Datum för träffen</Label>
        <Input
          id="date"
          type="date"
          value={formData.date}
          onChange={(e) => onInputChange('date', e.target.value)}
          required
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="participants_count">Antal deltagare</Label>
        <Input
          id="participants_count"
          type="number"
          min="0"
          value={formData.participants_count}
          onChange={(e) => onInputChange('participants_count', parseInt(e.target.value))}
          required
        />
      </div>
    </div>
  );
};